import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/country-multipliers")({
  beforeLoad: () => {
    throw redirect({
      to: "/dashboard/admin/settings",
      search: { section: "pricing" },
    });
  },
});
